import uniqBy from "lodash/uniqBy";
import isEmpty from "lodash/isEmpty";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";

export function getOnlyNumbers(value) {
  if (typeof value === "string") return value.replace(/\D/g, "");
  return null;
}

export function hasDuplicatesFiles(array) {
  if (!array || !Array.isArray(array)) return false;
  return uniqBy(array, "name").length !== array.length;
}

export function getNames(fullName) {
  if (isEmpty(fullName)) return ["", ""];

  const names = fullName.split(" ");
  const firstName = names[0];
  let lastName = "";

  if (names.length > 1) {
    names.shift();
    lastName = names.join(" ");
  }

  return [firstName, lastName];
}

export function DbDateToJsDate(date) {
  if (!date) return undefined;
  return format(new Date(date), "MM/dd/yyyy", { locale: enUS });
}

export function DbDateToJsFullDate(date) {
  if (!date) return undefined;
  return format(new Date(date), "MM/dd/yyyy HH:mm aa", { locale: enUS });
}

export function DbDateToJsDateTime(date) {
  if (!date) return undefined;
  return format(new Date(date), "MM/dd/yy hh:mm:ss a", { locale: enUS });
}

// Get UTC date from current date
export function getUTCDate(date = new Date()) {
  if (!date) return undefined;
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

export function areFieldsCompleted(fields, entity) {
  return fields.every(field => entity[field]);
}

export function addProtocolToUrl(url) {
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  return url;
}

export function roundToNearestTenth(value) {
  return (Math.round(value * 10) / 10)
    .toFixed(2)
    .replace(/\.00$/, "")
    .replace(/(\.\d)0$/, "$1");
}

export function formatNumber(value) {
  if (value == null) return "";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatMoney(value) {
  if (value == null) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
}

export function formatPercentage(value) {
  if (value == null) return "";
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(value / 100);
}

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber || !/^\d{10}$/.test(phoneNumber)) return phoneNumber; // Ensure it's non-null and a 10-digit number

  const areaCode = phoneNumber.slice(0, 3);
  const centralOfficeCode = phoneNumber.slice(3, 6);
  const lineNumber = phoneNumber.slice(6);

  return `(${areaCode}) ${centralOfficeCode} ${lineNumber}`;
}

export function getDomainUrl() {
  if (typeof window !== "undefined" && window.location) {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return "";
}
